import { render } from "./SniplyInvite.vue?vue&type=template&id=7f01e3c0"
import script from "./SniplyInvite.vue?vue&type=script&lang=js"
export * from "./SniplyInvite.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__